import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { ProfileService } from '../../../../core/services/profile.service';
import { TableauService } from '../../../../services/tableau.service';

@Component({
    selector: 'msr-tableau',
    templateUrl: './msr-tableau.component.html',
    styleUrls: ['./msr-tableau.component.scss'],
    standalone: false
})
export class MsrTableauComponent implements OnInit {
    @Input() data: any;
    @Input() dashboards$: Observable<any>;

    public model: any = {
        dashboard: '',
        message: '',
        agree: false

    };

    public tableauMessage: string = "";

    constructor(
        public tableauService: TableauService,
        public profileService: ProfileService,
        private toaster: ToastrService,
    ) {}


    public ngOnInit(): void { }

    public addTableauRequest() {
        this.tableauService.newTableauRequest$.next({ Dashboard: this.model.dashboard, Message: this.model.message, Agree: this.model.agree });
        this.toaster.success('Tableau request added!', '', {
            positionClass: 'toast-top-full-width'
        });
        this.model.dashboard = "";
        this.model.message = "";
        this.model.agree = false;
    }
}


